import { mixins } from 'vue-class-component'
import { Component } from 'vue-property-decorator'

import AppBreadcrumbs from '@/components/AppBreadcrumbs.vue'
import AppDialog from '@/components/AppDialog.vue'
import AppRefreshAndExport from '@/components/AppRefreshAndExport.vue'
import AppSimpleButton from '@/components/AppSimpleButton.vue'
import { Breadcrumb } from '@/interfaces/breadcrumbs'
import { utcDateTimeToLocal } from '@/utils/dateTime'
import MemberDialog from '../MemberList/script-dialog'
import { showErrors } from '@/utils/snack'
import { findMember } from './gql'
import { TypedGqlError } from '@/interfaces/error'

@Component({
  components: {
    AppBreadcrumbs,
    AppRefreshAndExport,
    AppDialog,
    AppSimpleButton
  }
})

export default class MemberDetail extends mixins(MemberDialog) {
  breadcrumbs: Breadcrumb[] = [
    {
      text: '会员管理'
    },
    {
      text: '会员管理',
      to: { name: 'MemberList' }
    }

  ]

  disableConfirm = false

  windowSize = {
    w: 0,
    h: 0
  }

  loading = false
  headers = [
    { text: '学校', value: 'school', sortable: false },
    { text: '入学年', value: 'year', sortable: false },
    { text: '班', value: 'className', sortable: false },
    { text: '学生姓名', value: 'realname', sortable: false },
    { text: '联系电话', value: 'phone', sortable: false },
    { text: '是否默认', value: 'isDefault', sortable: false }
  ]

  addresses: any[] = []

  options = {
    sortBy: ['m_createdAt'],
    itemsPerPage: 10,
    sortDesc: [true]
  }

  utcDateTimeToLocal = utcDateTimeToLocal

  async mounted () {
    this.onResize()
    this.getMemberById()
  }

  async getMemberById () {
    const { id } = this.$route.params
    try {
      const result = await this.$apollo.query({
        query: findMember,
        variables: {
          memberId: +id
        }
      })
      const member = result.data.findMember
      this.breadcrumbs.push({ text: `${member.uniqueId}` })
      this.targetMember = member
      this.addresses = member.addresses
    } catch (error) {
      const typedError = error as TypedGqlError
      showErrors(typedError.graphQLErrors)
    }
  }

  async deleteConfirm () {
    await this.deleteRequest()
    this.$router.push({
      name: 'MemberList'
    })
  }

  onResize () {
    this.windowSize = { w: window.innerWidth, h: window.innerHeight }
  }
}
